export interface INickSearchField {
    smartSearch: boolean;
    advanced: boolean;
}
